import { SupervisionManagementApi } from './../api/supervision-management.api';
import {Injectable} from '@angular/core';
import { SessionService } from '@edl-development/edl-common';

@Injectable()
export class SupervisionManagementService {

    constructor(private  smuiApi: SupervisionManagementApi, private sessionService: SessionService) { }

    getSmuiData = ({ offset, limit, searchBy, userType, bid, year, isSupervisorOnly, isActionNeededOnly, ascending } :
        {
            offset:number,
            limit:number,
            searchBy?:string,
            userType?:string,
            bid?: number,
            year?: string,
            isSupervisorOnly?: boolean,
            isActionNeededOnly?: boolean,
            ascending?: boolean
        }) =>
            this.smuiApi.getSmuiData({ searchBy, offset, limit, userType, bid, year, isSupervisorOnly, isActionNeededOnly, ascending });
}
